import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StaticMsgModule } from '@lib/pipes';
import { JuniorPilotRequestSubHeaderComponent } from './junior-pilot-request-sub-header.component';
import { RouterModule } from '@angular/router';
import { TextTooltipModule } from '@lib/components';
import { TooltipDirectiveModule } from '@lib/directives';

@NgModule({
  declarations: [JuniorPilotRequestSubHeaderComponent],
  imports: [CommonModule, StaticMsgModule, RouterModule, TextTooltipModule, TooltipDirectiveModule],
  exports: [JuniorPilotRequestSubHeaderComponent],
})
export class JuniorPilotRequestSubHeaderModule {}
